const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const getDateFromMillis = (millis) => {
    let date = new Date(millis);
    return `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()} ${date.getDate()}-${months[date.getMonth()]}-${date.getFullYear()}`;
}

/**
Generates data appropriate to the API in the following form
    data: {
      topic:                    string - mandatory   (oneOf: [airfind, airfind-test])
      payload: {        
        title:                  string  - mandatory
        text:                   string  - mandatory
        type:                   string  - mandatory  (oneOf: [link/reply])
        url:                    string  - optional
        imageUrl:               string  - optional
        iconUrl:                string  - optional
      }
      target: {
          clientId:             string  - mandatory
          affiliateId:          string  - mandatory
          appId:                string  - mandatory
          pushApiVersion:       numeric - optional
          appVersion:           string  - optional
          osVersion:            string  - optional
          country:              string  - optional
          language:             string  - optional
          lastSeen:             numeric - optional
      }
    }
*/
export const generateDataToSend = (formData) => {
    let dataToSend = {};
    console.log(formData);
    for (var prop in formData) {
        if (formData[prop] && formData[prop].error) {
            alert("please fix errors above");
            return null;
        }
        if (!formData[prop].value && formData[prop].value === '') {
            continue;
        }
        if (formData[prop].root) {
            let arr = formData[prop].root.split(".");
            let container;
            arr.forEach(element => {
                if (!container) {
                    if (!dataToSend[element]) {
                        dataToSend[element] = {};
                    }
                    container = dataToSend[element];
                } else if (!container[element]) {
                    container[element] = {};
                    container = container[element];
                } else {
                    container = container[element];
                }
            });
            container[prop] = formData[prop].value;
        } else {
            dataToSend[prop] = formData[prop].value;
        }
    }
    return dataToSend;
}

export const printHttpError = (error) => {
    if (error.response)
        return `Error (${error.response.status}): ${JSON.stringify(error.response.data)}`;

    return JSON.stringify(error);
}